import React, { useState, useEffect } from "react";
import {
  TableEditBtn,
  TableViewBtn,
  TableDeleteBtn,
} from "../../../images/Svgs";
import { CustomToolTip } from "../../../utils/common";

const Userlist = ({
  allUser,
  onEditUser,
  onDeleteUser,
  onAccessChange,
  onUserDetail,
}) => {
  const [userDetail, setUserDetail] = useState(null);

  useEffect(() => {
    const storedUserDetail = localStorage.getItem("userDetail"); // Retrieve from local storage
    if (storedUserDetail) {
      setUserDetail(JSON.parse(storedUserDetail)); // Parse JSON string to object
    }
  }, []);

  const handleAccessChange = async (user, value) => {
    let payload = {
      user_id: user.id,
      first_name: user?.first_name,
      last_name: user?.first_name,
      email: user.email,
      role_id: user.roles ? user.roles.id : null,
      is_active: user.is_active ? 1 : 0,
      is_access: value ? 1 : 0,
    };
    await onAccessChange(payload);
  };
  return (
    <div className="">
      <div className="row">
        <div className="col-12">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">User Name</th>
                <th scope="col">Email Address</th>
                <th scope="col">User Role</th>
                <th scope="col">Status</th>
                <th scope="col">Logistics Access</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {allUser &&
                allUser.length > 0 &&
                allUser.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td scope="row" className="text_capitalize">
                        {/* <input type="checkbox" /> */}
                        {`${item?.first_name ? item?.first_name : ""} ${
                          item?.last_name ? item?.last_name : ""
                        }`}
                      </td>
                      <td>{item.email}</td>
                      <td>{item?.roles ? item.roles.name : "NA"}</td>
                      <td
                        className={`${item.is_active ? "active" : "deactive"}`}
                      >
                        {item.is_active ? "Active" : "Deactive"}
                      </td>
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`flexSwitchCheckDefault-${item.id}`}
                            onChange={(e) =>
                              handleAccessChange(item, e.target.checked)
                            }
                            checked={item.is_access}
                            disabled={item?.roles?.id !== 2 ? true : false}
                          />
                        </div>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn position-relative"
                          onClick={() => onEditUser(item)}
                        >
                          <TableEditBtn />
                          <CustomToolTip type="edit" title="User" />
                        </button>
                        <button
                          type="button"
                          className="btn position-relative"
                          onClick={() => onUserDetail(item)}
                        >
                          <TableViewBtn />
                          <CustomToolTip type="view" title="User" />
                        </button>
                        <button
                          type="button"
                          className="btn position-relative"
                          onClick={() => onDeleteUser(item.id)}
                        >
                          <TableDeleteBtn />
                          <CustomToolTip type="delete" title="User" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Userlist;
